/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Kind_TitleInputs */

const en_fw_bm_kind_title = /** @type {(inputs: Fw_Bm_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By criterion kind and layer`)
};

const id_fw_bm_kind_title = /** @type {(inputs: Fw_Bm_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per jenis kriteria dan lapisan`)
};

/**
* | output |
* | --- |
* | "By criterion kind and layer" |
*
* @param {Fw_Bm_Kind_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_kind_title = /** @type {((inputs?: Fw_Bm_Kind_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Kind_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_kind_title(inputs)
	return en_fw_bm_kind_title(inputs)
});